import React from 'react'

export default function Header() {
  return (
    <div className='header'>
      <img src="logo.png" alt="moviedux" className="logo" />
      <h2 className="app-subtitle">it's time for popcorn! Find your next movie here.</h2>
    </div>
  )
}
